import { Check, Languages } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

import { useI18n, type Language } from 'src/i18n';

// ----------------------------------------------------------------------

export type LanguagePopoverProps = React.ComponentProps<typeof Button>;

const languages: { value: Language; labelKey: string; shortLabel: string }[] = [
  { value: 'en', labelKey: 'language.english', shortLabel: 'EN' },
  { value: 'zh-CN', labelKey: 'language.simplifiedChinese', shortLabel: '中' },
];

export function LanguagePopover({ className, ...other }: LanguagePopoverProps) {
  const { language, setLanguage, t } = useI18n();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={cn('h-9 gap-1 rounded-full px-2 text-xs font-medium', className)}
          aria-label={t('language.label')}
          {...other}
        >
          <Languages className="h-4 w-4" />
          <span className="min-w-5">{languages.find((item) => item.value === language)?.shortLabel}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="z-[2100] w-40">
        {languages.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => setLanguage(option.value)}
            className={cn(
              'flex items-center justify-between gap-3',
              option.value === language && 'bg-accent font-semibold',
            )}
          >
            <span>{t(option.labelKey)}</span>
            {option.value === language && <Check className="h-4 w-4" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export const CountryPopover = LanguagePopover;
